import { render, staticRenderFns } from "./SlidesOrder.vue?vue&type=template&id=799750ce&scoped=true"
import script from "./SlidesOrder.vue?vue&type=script&lang=js"
export * from "./SlidesOrder.vue?vue&type=script&lang=js"
import style0 from "./SlidesOrder.vue?vue&type=style&index=0&id=799750ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "799750ce",
  null
  
)

export default component.exports